const router = {
  NEW_CADASTRO: 'gat/cadastroColetivo',
  RETIFICAR: 'gat/retificacaoCadastro',
  EDITAR: 'gat/cadastroColetivo'
}

export default {
  router
}



// WEBPACK FOOTER //
// ./src/utils/ba/regrasArrecadacao.js